import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDate(date: Date | string): string {
  return new Date(date).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(amount);
}

/**
 * Strip presigned query params from S3/CloudFront URLs to get the permanent public URL.
 * The plantista-prod-storage bucket has a public-read policy, so direct URLs work permanently.
 * Presigned URLs expire after 60 minutes and cause broken images on session restore.
 */
export function toPermanentUrl(url: string | null | undefined): string {
  if (!url) return "";
  try {
    const parsed = new URL(url);
    // Remove AWS presigned params (X-Amz-*)
    const keysToRemove: string[] = [];
    parsed.searchParams.forEach((_, key) => {
      if (key.startsWith("X-Amz")) {
        keysToRemove.push(key);
      }
    });
    keysToRemove.forEach((key) => parsed.searchParams.delete(key));
    return parsed.toString();
  } catch {
    return url;
  }
}
